import type { IconProps } from './types';

export const EquationIcon = (props: IconProps) => {
  const {
    size = 24,
    width = size,
    height = size,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M4.25 18.5195C4.25 18.0796 4.42517 17.6578 4.73633 17.3467L10.3682 11.7139L4.73633 6.08203C4.42519 5.77089 4.25001 5.34919 4.25 4.90918C4.25 3.99286 4.99286 3.25 5.90918 3.25H18.5C18.9142 3.25 19.25 3.58579 19.25 4C19.25 4.41421 18.9142 4.75 18.5 4.75H5.90918C5.82128 4.75 5.75 4.82128 5.75 4.90918C5.75001 4.95136 5.76703 4.99164 5.79688 5.02148L11.959 11.1836C12.2518 11.4764 12.2516 11.9512 11.959 12.2441L5.79688 18.4072C5.76707 18.437 5.75 18.4773 5.75 18.5195C5.75005 18.6074 5.82132 18.6787 5.90918 18.6787H18.5L18.5771 18.6826C18.9551 18.7212 19.25 19.0405 19.25 19.4287C19.2499 19.8168 18.9551 20.1362 18.5771 20.1748L18.5 20.1787H5.90918C4.99288 20.1787 4.25005 19.4358 4.25 18.5195Z"
        fill={color}
      />
    </svg>
  );
};
